import { css } from 'styled-components';
import { prem } from 'styles/helpers/spacing';

const ResourcesWrapper = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: ${prem(16)};
`;

export { ResourcesWrapper };
